import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, unref as _unref, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { key: 0 }

import { Document } from "@element-plus/icons-vue"
import ComDownloadButton from "@/components/common/buttons/ComDownloadButton.vue"
import { LiiteResponse } from "@/api/models/liite-response"


export default /*@__PURE__*/_defineComponent({
  __name: 'ComHuonekorttiLiitteetTable',
  props: {
    liitteet: {},
    loading: { type: Boolean }
  },
  emits: ["downloadLiite"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (__props.loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_el_skeleton, {
          rows: 2,
          animated: ""
        })
      ]))
    : (!__props.liitteet || __props.liitteet.length === 0)
      ? (_openBlock(), _createBlock(_component_el_empty, {
          key: 1,
          description: "Ei liitteitä",
          "image-size": 60
        }))
      : (_openBlock(), _createBlock(_component_el_table, {
          key: 2,
          data: __props.liitteet,
          size: "small",
          class: "tilat-table",
          style: {"width":"100%"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "Liitteet",
              "show-overflow-tooltip": ""
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_space, { size: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, { color: "var(--el-text-color-secondary)" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Document))
                      ]),
                      _: 1
                    }),
                    _createElementVNode("span", null, _toDisplayString(scope.row.nimi || scope.row.tiedosto), 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              width: "50",
              align: "center"
            }, {
              default: _withCtx((scope) => [
                _createVNode(ComDownloadButton, {
                  onClick: () => _ctx.$emit('downloadLiite', scope.row.id)
                }, null, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"]))
}
}

})